module.exports = __webpack_public_path__ + "img/ivan.d04c0c5e.png";